import {observable, computed, action, autorun, toJS} from 'mobx';
import translateBase from '../translate';
let translate = translateBase.bindComponent('commonPersonalData');
const $ = window.$;

export class VPersonalData {
  constructor(flasher, api, navigation, organization, masterData, authentication, personalData, rentalTransaction, 
    rentalObject, businessUnit, bestOffers, personalDataForm, personalAddressForms, validator, vUserRegistration, searchForm, vBookingWizard) {
    this.flasher = flasher;
    this.api = api;
    this.navigation = navigation;
    this.organization = organization;
    this.masterData = masterData;
    this.authentication = authentication;
    this.personalData = personalData;
    this.rentalTransaction = rentalTransaction;
    this.rentalObject = rentalObject;
    this.businessUnit = businessUnit;
    this.bestOffers = bestOffers;
    this.personalDataForm = personalDataForm;
    this.personalAddressForms = personalAddressForms;
    this.validator = validator;
    this.vUserRegistration = vUserRegistration;
    this.searchForm = searchForm;
    this.vBookingWizard = vBookingWizard;
    this.reactions = [];
  }

  @computed get isGuestAllowed() {
    return !this.organization.isClosedUserGroup;
  }

  @observable showGuestLogin = false;
  @observable usingPostAsBilling = true;
  @observable registrationPerformed = false;
  @observable hasBeenSubmitted = false;


  /*async load() { 
    await Promise.all([
      this.masterData.load(),
      this.rentalTransaction.loadOrBegin(),
      this.organization.load(),
    ]);
  }*/

  @action.bound usePostAsBilling() {
    this.usingPostAsBilling = !this.usingPostAsBilling; 
  }

  @action.bound setFormsReadOnly(state) {
    this.personalDataForm.readOnlyAll = state;
    /*for(let paf of this.personalAddressForms) {
      paf.readOnlyAll = state;
    }*/
  }
 
  @action.bound async registerUser() {
    try { 
      this.flasher.setOther('Loading.');
      await this.vUserRegistration.registerUser({
        orgId: this.orgId,
      });
      this.registrationPerformed = true;
    }
    catch(e) {
      this.flasher.handleError(e);
      throw e
    }
    finally {
      this.flasher.setOther();
    }
  }

  async startOrUpdate({orgId, trxId}) {
    this.vBookingWizard.setVisitedStep(4);
    this.personalDataForm.setPurpose(this.personalDataForm.PURPOSES.GUEST_BOOKING); 
    try {    
      this.flasher.setOther('Loading.');
      await Promise.all([
        this.masterData.cFetch(),
        this.rentalTransaction.fetch({orgId, trxId}),
        this.organization.cFetch({orgId}),
      ]);
      let objId = this.rentalTransaction.refRentalObjectId; 
      await Promise.all([
        this.rentalObject.cFetch({orgId, objId,}),
        this.bestOffers.cFetch({
          startDate: this.rentalTransaction.realRentingStartDate, //window.sessionStorage.getItem('bwStartDate'), //this.startDate,  
          endDate: this.rentalTransaction.realRentingEndDate, //window.sessionStorage.getItem('bwEndDate'), //this.endDate, 
          organizationId: this.orgId,
          objectId: objId, 
          timeUnit: this.searchForm.timeUnit, 
          oldStartDate: undefined, 
          oldEndDate: undefined,
        })         
      ]);       
      await this.businessUnit.cFetch({
        businessUnitId: this.rentalObject.businessUnitId,
      });      
    }
    catch(e) {
      this.flasher.handleError(e);
      //throw e
    }
    finally {
      this.updateInProgress = false;
      this.flasher.setOther();
    }    

    let lastLoggedIn = this.authentication.loggedIn;

    this.stopReactions();
    this.reactions.push(autorun(() => {
      if(this.usingPostAsBilling) {
      } else {
        //this.personalAddressForms[1].reset();
      }
    }));


    let oldLoggedIn = this.authentication.loggedIn;
    this.reactions.push(autorun(async() => {
      let loggedIn = this.authentication.loggedIn;
      if(true || lastLoggedIn !== loggedIn) {
        lastLoggedIn = loggedIn;
        if(loggedIn) {
          this.setFormsReadOnly(true);
          try {
            await this.personalData.fetch({orgId});    
          } 
          catch(e) {
            this.flasher.handleError(e);
          }
          finally {
            this.updateInProgress = false;
            this.flasher.setOther();
          }                
          this.personalDataForm.reset({
            salutation: this.personalData.salutation,
            firstName: this.personalData.firstName,
            lastName: this.personalData.lastName,
            organization: this.personalData.organization,
            email: this.personalData.email,
            phone: this.personalData.phone,
            mobilePhone:  this.personalData.mobilePhone
          });
          this.personalAddressForms.forEach(o => {
            const address = this.personalData.addresses[o.refAddressTypeId] || {};
            if(!o.isDirty || (loggedIn && !oldLoggedIn)) {
              o.reset({
                street: address.street,
                addition: address.addition || '',
                postalCode: address.postalCode,
                city: address.city,
                country: address.country,
              })
            }
          });
        } else {
          if(!loggedIn && oldLoggedIn) {
            this.setFormsReadOnly(false);
            this.personalDataForm.reset({
              salutation: '',
              firstName: '',
              lastName: '',
              email: '',
              phone: '',
              oldPassword: '',
              password1: '',
              password2: '',
            });
            this.personalAddressForms.forEach(o => {
              o.reset({
                street: '',
                addition: '',
                postalCode: '',
                city: '',
                country: '',
              })
            });      
          }           
        }
      }
      oldLoggedIn = loggedIn;
    }));
  }

  @action.bound fillByPostAddr(addrIdx) {
    for(let k in this.personalAddressForms[0].values) {
      this.personalAddressForms[addrIdx].dirtyValues[k] = this.personalAddressForms[0].values[k];
    }
  }

  @action.bound submit() {    
    try {
      if(this.showGuestLogin) {
        if(this.usingPostAsBilling) {
          this.fillByPostAddr(1);
        }        
        this.personalDataForm.setPurpose(this.personalDataForm.PURPOSES.GUEST_BOOKING);
        this.personalDataForm.visitAll();
        if(!this.personalDataForm.allValid) {
          throw new Error(translate("errInvalidFields", "Some of the form fields are not valid."));
        }
    
        this.personalAddressForms[0].visitAll();
        if(!this.personalAddressForms[0].allValid) {
          throw new Error(translate("errInvalidFields", "Some of the form fields are not valid."));
        }
        if(!this.usingPostAsBilling) {
          this.personalAddressForms[1].visitAll();
          if(!this.personalAddressForms[1].allValid) {
            throw new Error(translate("errInvalidFields", "Some of the form fields are not valid."));
          }        
        }
        this.hasBeenSubmitted = true;   
      } else {
        this.personalAddressForms[0].visitAll();
        if(!this.personalAddressForms[0].allValid) {
          throw new Error(translate("errInvalidFields", "Some of the form fields are not valid."));
        }
        if(!this.usingPostAsBilling) {
          this.personalAddressForms[1].visitAll();
          if(!this.personalAddressForms[1].allValid) {
            throw new Error(translate("errInvalidFields", "Some of the form fields are not valid."));
          }        
        }
        this.hasBeenSubmitted = true; 
      }
    }
    catch(e) {
      this.flasher.handleError(e)
      return
    }

    this.navigation.goBWReview();
  }

  @action.bound stop() {
    this.stopReactions();

  }

  @action.bound stopReactions() {
    this.reactions.forEach(ar => ar());
    this.reactions = [];
  }    
}


// WEBPACK FOOTER //
// ./src/view/VPersonalData.js